export default {
  SET_PORTALS: (state, { portals }) => {
    state.portals = portals
  }
}
